<template>
  <v-layout row class="row-wrapper">
    <v-flex v-if="isLabelVisible"
            :xs6="isDocumentListVisible && isUploadButtonVisible"
            :xs9="isDocumentListVisible ^ isUploadButtonVisible"
            :xs12="!isDocumentListVisible && !isUploadButtonVisible"
            class="center-left">
      <slot name="label">
        <span class="pt-2 pl-2">{{ label }}<sup v-if="showMandatoryIndicator" class="redtext ml-1">*</sup></span>
      </slot>
    </v-flex>

    <v-flex v-if="isDocumentListVisible"
            :xs3="isLabelVisible || isUploadButtonVisible"
            :xs12="!isLabelVisible && !isUploadButtonVisible">
      <v-chip class="justify-start download-chip right text--green" outline label small color="success"
              :close="!readonly"
              v-for="(doc, index) in displayedDocumentList"
              @input="onFileRemove(doc.dui)"
              @click="onFileDownload(doc.dui)"
              :key="doc.dui">
        {{ !!doc.fileName ? doc.fileName : `file(${index + 1})` }}
      </v-chip>
      <v-chip class="justify-start no-file-chip right" outline label small color="grey lighten-2"
              v-if="displayedDocumentList.length === 0"
              :key="'no-data-chip'">
        {{ noFileAttachedLabel }}
      </v-chip>
    </v-flex>

    <v-flex v-if="isUploadButtonVisible"
            xs3>
      <input ref="file" hidden type="file" :accept="acceptedTypes" @change="onFileChange"/>
      <v-btn flat
             @click="onUploadBtnClick"
             class="upload-btn"
             :class="{'disabled-btn': disabled, 'grey--text': disabled}"
             :loading="isLoading === true">
        {{ uploadButtonLabel }}
        <v-icon dark :class="{'v-icon--right': isBtnLabelVisible}">cloud_upload</v-icon>
        <v-icon size="18" color="orange" class="align-self-center ml-2"
                v-show="showErrorIndicator">warning
        </v-icon>
      </v-btn>
      <div id="downloadFiles" style="visibility:hidden"></div>
    </v-flex>
  </v-layout>
</template>

<script>
import documentApi from '@/services/DocumentApi'

export default {
  name: 'DocumentUploaderInline',
  props: {
    value: Boolean, // value here is the v-model specified at the parent level
    label: String,
    uploadButtonLabel: String,
    noFileAttachedLabel: String,
    acceptedTypes: String,
    maxSize: Number,
    documentType: String,
    documentList: Array,
    showMandatoryIndicator: Boolean,
    showErrorIndicator: Boolean,
    readonly: Boolean,
    allowMultipleUploads: Boolean,
    disabled: Boolean
  },
  emits: ['fileUploaded', 'fileRemoved'],
  data () {
    return {
      isLoading: false
    }
  },
  mounted () {
    this.isLoading = false
  },
  computed: {
    isLabelVisible () {
      return (!!this.label && this.label.length > 0) || this.$slots.label
    },
    isBtnLabelVisible () {
      return !!this.uploadButtonLabel && this.uploadButtonLabel.length > 0
    },
    displayedDocumentList () {
      return !!this.documentList ? this.documentList : []
    },
    isUploadButtonVisible () {
      return !this.readonly &&
        (this.allowMultipleUploads || this.documentList.length === 0)
    },
    isDocumentListVisible () {
      return (!!this.documentList && this.documentList.length > 0) || this.readonly
    }
  },
  methods: {
    async onFileChange (event) {
      if (event.target.files.length > 0) {
        const file = event.target.files[0]
        if (!!file && !!file.type && !!file.name) {
          try {
            this.isLoading = true
            const uploadRequestResult = await documentApi.requestDocumentUpload(file.name, file.type)
            const binaryUploadResult = await documentApi.uploadDocument(uploadRequestResult.presignedUrl, file)
            const uploadedDocumentId = uploadRequestResult.hasOwnProperty('dui') ? uploadRequestResult.dui : uploadRequestResult.documentId

            if (binaryUploadResult) {
              const eventPayload = {
                documentType: this.documentType,
                fileName: uploadRequestResult.fileName,
                dui: uploadedDocumentId
              }
              this.$emit('fileUploaded', eventPayload)
            }
          } finally {
            this.isLoading = false
          }
        }
      }
    },
    onUploadBtnClick () {
      if (this.disabled === false) {
        this.$refs.file.value = null
        this.$refs.file.click()
      }
    },
    onFileRemove (dui) {
      if (!!dui) {
        this.$emit('fileRemoved', dui)
      }
    },
    async onFileDownload (dui) {
      const doc = await documentApi.getDocument(dui)
      const a = document.createElement('a')
      a.href = doc.presignedUrl
      a.download = doc.fileName
      $('#downloadFiles').append(a)
      a.click()
      a.remove()
    }
  }
}
</script>

<style scoped>
.center-left {
  align-self: center;
  text-align: start;
}

.row-wrapper {
  /*padding-left: 5px;*/
  padding-right: 5px;
}

.row-wrapper:hover {
  background-color: #f5f5fe;
}

.upload-btn {
  border-width: 1px;
  border-style: dashed;
  border-color: gray;
}

.disabled-btn {
  pointer-events: none
}

>>> span.download-chip > span {
  cursor: pointer;
  color: #4caf50;
}

>>> span.no-file-chip > span {
  pointer-events: none;
  color: #BDBDBD;
}
</style>
